import { render, staticRenderFns } from "./projects.vue?vue&type=template&id=40e13172&"
import script from "./projects.ts?vue&type=script&lang=ts&"
export * from "./projects.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports